export const ARTWORK_STATUSES: {
  unreviewed: 'UNREVIEWED';
  approved: 'APPROVED';
  rejected: 'REJECTED';
} = {
  unreviewed: 'UNREVIEWED',
  approved: 'APPROVED',
  rejected: 'REJECTED'
};

export enum ARTWORK_SUMMARY_STATUSES {
  approved = 'APPROVED',
  rejected = 'REJECTED',
  inProgress = 'IN_PROGRESS',
}
